export default "__VITE_ASSET__7xK$cWL1__"